import { TestTemplatesTab } from '../../components/TestTemplatesTab';

export function SuperadminTestTemplates() {
  return <TestTemplatesTab />;
}
